$(document).ready(function () {
function price_calculate(_this,bundle_off){
 var main_price = 0;
  var bundle_off =parseInt(bundle_off);
     var compare_price = 0;
    $('.main_bundle_product .bundle-product-list .bndl_pd_check:checked').each(function(){
        main_price = main_price+parseInt($(this).parents('.bundle-product-list').find('.card-information .price__regular .bundle_price_off').attr('data-actual-p'));
        compare_price =  compare_price+parseInt($(this).parents('.bundle-product-list').find('.card-information .price__regular .bundle_price_off').attr('data-original-price'));
    });
   var main_p_price = parseInt($('.product__info-wrapper .product-form .product-form__submit .price').attr('data-price'));
    var main_comp_price = parseInt($('.product__info-wrapper .product-form .product-form__submit .sale-price').attr('data-comp-price'));
    if(isNaN(main_comp_price)){
      main_comp_price = main_p_price;
    }
    var total_price = main_p_price+main_price;
    var total_comp_price = main_comp_price+compare_price;
    var actual_price_total =Shopify.formatMoney(total_price);
    var comp_price_total =Shopify.formatMoney(total_comp_price);
   $('.product__info-wrapper .product-form .product-form__submit .price').html(actual_price_total);
    $('.product__info-wrapper .product-form .product-form__submit .sale-price').html(comp_price_total)
}
$(document).on('click','.main_bundle_product .bundle-product-list .bndl_pd_check',function(){
   var bundle_off = $(this).attr('data_off');
   var p_id = $(this).attr('data-id');
   var _this =this;
   price_calculate(_this,bundle_off);
   var main_p_price = parseInt($('.product__info-wrapper .product-form .product-form__submit .price').attr('data-price'));
   var main_comp_price = parseInt($('.product__info-wrapper .product-form .product-form__submit .sale-price').attr('data-comp-price'));
  
   if($('.main_bundle_product .bundle-product-list .bndl_pd_check:checked').length >0){
        $('.product__info-wrapper .product-form input.main_pd_random_no').attr('disabled',false);
        $('.product__info-wrapper .product-form input.product_type').attr('disabled',false);
        $('.product__info-wrapper .product-form input.budle_off').attr('disabled',false);
      
   }else{
     var main_price =  $('.product__info-wrapper .product-form .buttonPrice').attr('data-price');
        $('.product__info-wrapper .main-price-container .price__regular .price-item--regular').html(main_price);
          var main_comp_price = parseInt($('.product__info-wrapper .product-form .product-form__submit .sale-price').attr('data-comp-price'));
            if(isNaN(main_comp_price)){
                $('.product__info-wrapper .product-form .product-form__submit .sale-price').html('');
            }
         $('.product__info-wrapper .product-form input.main_pd_random_no').attr('disabled',true);
       $('.product__info-wrapper .product-form input.product_type').attr('disabled',true);
        $('.product__info-wrapper .product-form input.budle_off').attr('disabled',true);
   }
    if($(this).hasClass('first')){
        if($(this).is(':checked')){
            $('.product__info-wrapper .product-form input.combo_pd_id1').val(p_id);
            $('.product__info-wrapper .product-form input.budle_off2').val(bundle_off);
            $('.product__info-wrapper .product-form input.budle_off1').val(bundle_off);
            $('.product__info-wrapper .product-form input.budle_off').val(bundle_off);
            $('.product__info-wrapper .product-form input.bundle_attr1').attr('disabled',false)
        }else{
            $('.product__info-wrapper .product-form input.bundle_attr1').attr('disabled',true)
        }
        if($(this).parents('.bundle-product-list').find('.custm-no-discount.card__information').length > 0){
          $('.product__info-wrapper .product-form input.bundle_attr1[name="items[1][properties[_bundle_off]"]').val(0);
        }
    }else{
        if($(this).is(':checked')){
          $('.product__info-wrapper .product-form input.combo_pd_id2').val(p_id);
          $('.product__info-wrapper .product-form input.budle_off2').val(bundle_off);
            $('.product__info-wrapper .product-form input.budle_off1').val(bundle_off);
            $('.product__info-wrapper .product-form input.budle_off').val(bundle_off);
            $('.product__info-wrapper .product-form input.bundle_attr2').attr('disabled',false)
        }else{
            $('.product__info-wrapper .product-form input.bundle_attr2').attr('disabled',true)
        }
      if($(this).parents('.bundle-product-list').find('.custm-no-discount.card__information').length > 0){
          $('.product__info-wrapper .product-form input.bundle_attr2[name="items[2][properties[_bundle_off]"]').val(0);
        }
    }
    
})

       var hide_mobile_bundle_pd = $('cart-drawer .grid__item.bundle-product-list.cart-hidden').length
            var hide_bundle_pd =$('cart-drawer .main_bundle_wraoer-container li.grid__item.bundle-product-list.cart-hidden').length
            var total_hide_bundle_pd = hide_mobile_bundle_pd+hide_bundle_pd;
            var total_mobile_bundle_pd = $('cart-drawer .grid__item.bundle-product-list').length;
            var total_bundle_pd = $('cart-drawer .main_bundle_wraoer-container li.grid__item.bundle-product-list').length;
            var total_bundle_pd_main = total_mobile_bundle_pd+total_bundle_pd;
            var total_show_pd = total_bundle_pd_main-total_hide_bundle_pd;
            if(total_show_pd < 1){
                $('cart-drawer .drawer_upsells').addClass('hide_active');
            }else{
                 $('cart-drawer .drawer_upsells').removeClass('hide_active');
            }
 
/***************** bogo product js *****************/
var id = $('.check_pd .bogo_pd-check').attr('data-id');
    var bogo_off = $('.check_pd .bogo_pd-check').attr('data_off');
  $('.product__info-wrapper.grid__item').find('product-form .bogo_product').attr('disabled',false);
    $('.product__info-wrapper.grid__item').find('product-form .bogo_pd_id1').val(id);
   $('.product__info-wrapper.grid__item').find('product-form .bogo_off1').val(bogo_off);
  
  $(document).on('change','.main-bogo-product-container .check_pd .bogo_pd-check',function(){
   
    if($(this).is(':checked')){
        
    $(this).parents('.product__info-wrapper.grid__item').find('product-form .bogo_product').attr('disabled',false);
   // $(this).parents('.product__info-wrapper.grid__item').find('product-form .bogo_pd_id1').val(id);
    $(this).parents('.product__info-wrapper.grid__item').find('product-form .bogo_off1').val(bogo_off);
    }else{
        $(this).parents('.product__info-wrapper.grid__item').find('product-form .bogo_product').attr('disabled','disabled'); 
    }

});
/***************** bogo product js end*****************/

$(document).on('change','.main-bundle-product-container .check_pd .bndl_pd_check',function(){
 
    var bundl_pd_lenght = $('.main-bundle-product-container .check_pd .bndl_pd_check:checked').length;

  if(bundl_pd_lenght == 2){
   $(this).parents('.main-bundle-product-container').find('.product-form__buttons .product-form__submit .change_bndle_check').html('both');
   }else{
    $(this).parents('.main-bundle-product-container').find('.product-form__buttons .product-form__submit .change_bndle_check').html('bundle');
   }
    $(this).parents('.main-bundle-product-container').find('.product-form__buttons .no_of_bundle_pd').html(bundl_pd_lenght+1);
      if(bundl_pd_lenght < 1){

        $(this).parents('.main-bundle-product-container').find('.product-form__buttons .product-form__submit').attr('disabled','disabled');
    }else
    {
          $(this).parents('.main-bundle-product-container').find('.product-form__buttons .product-form__submit').attr('disabled',false);
    }
 if($(this).hasClass('second')){
    if( $(this).is(':checked')){
     $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .random_no2').attr('disabled',false);
     $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .combo_pd_id2').attr('disabled',false);
     $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .budle_off2').attr('disabled',false);
     $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .combo_enable2').attr('disabled',false);
       $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .bndle_main_pd_handle2').attr('disabled',false);
    }else{
        $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .random_no2').attr('disabled','disabled');
     $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .combo_pd_id2').attr('disabled','disabled');
     $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .budle_off2').attr('disabled','disabled');
     $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .combo_enable2').attr('disabled','disabled');
      $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .bndle_main_pd_handle2').attr('disabled','disabled');
    }
 }else if($(this).hasClass('third') ){
    if($(this).is(':checked')){
     $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .random_no3').attr('disabled',false);
     $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .combo_pd_id3').attr('disabled',false);
     $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .budle_off3').attr('disabled',false);
     $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .combo_enable3').attr('disabled',false);
       $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .bndle_main_pd_handle3').attr('disabled',false);
 }else{
    $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .random_no3').attr('disabled','disabled');
        $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .bndle_main_pd_handle3').attr('disabled','disabled');
     $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .combo_pd_id3').attr('disabled','disabled');
     $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .budle_off3').attr('disabled','disabled');
     $(this).parents('.main-bundle-product-container').find('.bundle_main_add_to_cart .combo_enable3').attr('disabled','disabled');
 }
}
});
  /**************** mobile case bundle products ***************/
 var pd_id =[];
var bndl_off=[];
var selected_variant = $('variant-selects').find('.select__select option:selected').attr('data-value');

var save_price = 0;
var actual_price =0;
  var orignial_price =0;
if($('.main-bundle-product-container.active-bndl .grid__item .check_pd .check-input:checked').length >0){
$('.main-bundle-product-container.active-bndl .grid__item .check_pd .check-input:checked').each(function(e){
 save_price = parseInt($(this).parents('.bundle-product-list').find('.card-wrapper .bundle_price_off').attr('data-save-p')) + save_price;
  actual_price =  parseInt($(this).parents('.bundle-product-list').find('.card-wrapper .bundle_price_off').attr('data-actual-p')) + actual_price;
 orignial_price =  parseInt($(this).parents('.bundle-product-list').find('.card-wrapper .bundle_price_off').attr('data-original-price')) + orignial_price;
});
}

  /***** main bundle save price ************/

$('.main-bundle-product-container:not(.mobile-case-bndle-main) .check_pd .check-input:checked').each(function(e){
 save_price = parseInt($(this).parents('.bundle-product-list').find('.card-wrapper .bundle_price_off').attr('data-save-p')) + save_price;
  actual_price =  parseInt($(this).parents('.bundle-product-list').find('.card-wrapper .bundle_price_off').attr('data-actual-p')) + actual_price;
orignial_price =  parseInt($(this).parents('.bundle-product-list').find('.card-wrapper .bundle_price_off').attr('data-original-price')) + orignial_price;
});

 /***** main bundle save price end************/

var save_price_total =Shopify.formatMoney(save_price);
var actual_price_total =Shopify.formatMoney(actual_price);
    var orignial_price_total =Shopify.formatMoney(orignial_price);
$('.bundle_main_add_to_cart .total_main_container span.save_price').attr('data-save-price',save_price);
$('.bundle_main_add_to_cart .total_main_container span.main_price').attr('data-total',actual_price);
$('.bundle_main_add_to_cart .total_main_container span.save_price').html(save_price_total);
$('.bundle_main_add_to_cart .total_main_container span.main_price').html(actual_price_total);
 $('.bundle_main_add_to_cart .total_main_container span.orignial_price').attr('data-orignial_price',orignial_price);
$('.bundle_main_add_to_cart .total_main_container span.orignial_price').html(orignial_price_total);
// $('.main-bundle-product-container.mobile-case-bndle-main.active-bndl .bndl_mobile_check:checked').each(function(e){
//   var pd = $(this).attr('data-id');
//   var bdl_off =$(this).attr('data_off');
//    pd_id.push(pd);
//     bndl_off.push(bdl_off);
// });
// $('.bundle_main_add_to_cart .combo_pd_id1').val(pd_id[0]);
// $('.bundle_main_add_to_cart .combo_pd_id2').val(pd_id[1]);
// $('.bundle_main_add_to_cart .budle_off1').val(bndl_off[0]);
// $('.bundle_main_add_to_cart .budle_off2').val(bndl_off[1]);

$(document).on('change','.bndl_mobile_check',function(){
    var bundl_pd_lenght = $(this).parents('.main-bundle-product-container').find('.check_pd .bndl_mobile_check:checked').length;
if(bundl_pd_lenght == 2){
   $(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .product-form__submit .change_bndle_check').html('both');
   }else{
    $(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .product-form__submit .change_bndle_check').html('bundle');
   }
   $('.bundle_main_add_to_cart .no_of_bundle_pd').html(bundl_pd_lenght+1);
    if(bundl_pd_lenght < 1){

     $('.bundle_main_add_to_cart .product-form__buttons .product-form__submit').attr('disabled','disabled');
    }else
    {
          $('.bundle_main_add_to_cart .product-form__buttons .product-form__submit').attr('disabled',false);
    }
 if($(this).hasClass('second')){
    if( $(this).is(':checked')){
     $('.bundle_main_add_to_cart .random_no_1').attr('disabled',false);
     $('.bundle_main_add_to_cart .combo_pd_id1').attr('disabled',false);
     $('.bundle_main_add_to_cart .budle_off1').attr('disabled',false);
     $('.bundle_main_add_to_cart .combo_enable1').attr('disabled',false);
      $('.bundle_main_add_to_cart .bndle_main_pd_handle1').attr('disabled',false);
    
    
    }else{
      $('.bundle_main_add_to_cart .bndle_main_pd_handle1').attr('disabled','disabled');
       $('.bundle_main_add_to_cart .random_no_1').attr('disabled','disabled');
    $('.bundle_main_add_to_cart .combo_pd_id1').attr('disabled','disabled');
     $('.bundle_main_add_to_cart .budle_off1').attr('disabled','disabled');
     $('.bundle_main_add_to_cart .combo_enable1').attr('disabled','disabled');
     
    }
 }else if($(this).hasClass('third') ){
    if($(this).is(':checked')){
      $('.bundle_main_add_to_cart .bndle_main_pd_handle2').attr('disabled',false);
    $('.bundle_main_add_to_cart .random_no_2').attr('disabled',false);
     $('.bundle_main_add_to_cart .combo_pd_id2').attr('disabled',false);
     $('.bundle_main_add_to_cart .budle_off2').attr('disabled',false);
     $('.bundle_main_add_to_cart .combo_enable2').attr('disabled',false);
     
 }else{
       $('.bundle_main_add_to_cart .bndle_main_pd_handle2').attr('disabled','disabled');
     $('.bundle_main_add_to_cart .random_no_2').attr('disabled','disabled');
    $('.bundle_main_add_to_cart .combo_pd_id2').attr('disabled','disabled');
     $('.bundle_main_add_to_cart .budle_off2').attr('disabled','disabled');
     $('.bundle_main_add_to_cart .combo_enable2').attr('disabled','disabled');
      
 }
}
    
});
/**************** mobile case bundle products end ***************/
/************************** bundle price change on checkbox ***************************/
$(document).on('change','.check-input',function(){
    var save_new= 0;
    var total_bundle_price_new =0;
  var total_bundle_Originalprice_new =0;
   var save_p = parseInt($(this).parents('.bundle-product-list').find('.card-information .price .price__regular .bundle_price_off').attr('data-save-p'));
   var actual_p = parseInt($(this).parents('.bundle-product-list').find('.card-information .price .price__regular .bundle_price_off').attr('data-actual-p'));
    var total_bundle_price = parseInt($(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .main_price').attr('data-total'));
    var total_save_price  =  parseInt($(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .save_price').attr('data-save-price'));
    var original_p = parseInt($(this).parents('.bundle-product-list').find('.card-information .price .price__regular .bundle_price_off').attr('data-original-price'));
    var total_Originalbundle_price = parseInt($(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .orignial_price').attr('data-orignial_price'));  
  if($(this).is(':checked')){
     save_new =total_save_price+save_p;
          total_bundle_price_new = total_bundle_price+actual_p;
       total_bundle_Originalprice_new = total_Originalbundle_price+original_p;
        var save_price_total =Shopify.formatMoney(save_new);
        var actual_price_total =Shopify.formatMoney(total_bundle_price_new);
      var original_price_total =Shopify.formatMoney(total_bundle_Originalprice_new); 
   
$(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .save_price').attr('data-save-price',save_new);
$(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .main_price').attr('data-total',total_bundle_price_new);
$(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .save_price').html(save_price_total);
$(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .main_price').html(actual_price_total);

$(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .orignial_price').html(original_price_total);    
$(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .orignial_price').attr('data-orignial_price',total_bundle_Originalprice_new);    
    }else{
         save_new =total_save_price-save_p;
          total_bundle_price_new = total_bundle_price-actual_p;
       total_bundle_Originalprice_new = total_Originalbundle_price-original_p;
        var save_price_total =Shopify.formatMoney(save_new);
var actual_price_total =Shopify.formatMoney(total_bundle_price_new);
var original_price_total =Shopify.formatMoney(total_bundle_Originalprice_new); 
    
$(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .save_price').attr('data-save-price',save_new);
$(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .main_price').attr('data-total',total_bundle_price_new);
$(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .save_price').html(save_price_total);
$(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .main_price').html(actual_price_total);
  $(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .orignial_price').html(original_price_total);    
$(this).parents('.main_mobile_bundle_container').find('.bundle_main_add_to_cart .orignial_price').attr('data-orignial_price',total_bundle_Originalprice_new);     
  }
});
/************************** bundle price change on checkbox End***************************/
});